export const API_URL = `http://localhost:3001/api`;

export const FETCH_OPTIONS = {
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
  },
};

export const QB_ROOT_PATH = 'https://mymathscloud.ams3.digitaloceanspaces.com/QuestionBank/';
